module.exports = __webpack_public_path__ + "assets/bk.a50508a5.svg";